<template>
    <label @click="triggerClick" :class="componentClassName">
        <span class="ir-icons">
            <span v-if="isTheBloodyThisSelected" class="dummy"><i class="far fa-dot-circle"></i></span>
            <span v-else class="dummy2"><i class="far fa-circle"></i></span>
            <input v-model="vm.isSelected" :value="valueMatch" type="radio" :style="{opacity: '0', width: '0', height: '0'}" />
        </span>
        <span class="ir-label">
            {{label === '_' ? '\u00A0' : label}}
        </span>
    </label>
</template>


<script>
    import util from '@/helpers/util';
    import Vue from 'vue';

    export default {
        name: "InputRadio",
        props: ['value', 'label', 'valueMatch', "sfx"],
        data() {
            return {
                vm: {
                    isSelected: null,
                    clickEmitted: false
                }
            };
        },
        computed: {
            componentClassName() {
                if (this.sfx === false || this.disabled) return "clickable input-radio";

                return "clickable input-radio sfx";
            },
            isTheBloodyThisSelected() {
                if (util.isNull(this.vm.isSelected)) {
                    return false
                }
                if (this.vm.isSelected === this.valueMatch) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        created() {
            this.init();

            this.$watch(() => this.$props, function (newValue) {
                this.init();
            }, { deep: true });

            this.$watch(() => this.vm, function (newValue) {
                this.$emit('input', this.vm.isSelected);
                Vue.nextTick(() => {
                    this.$emit('change');
                })
            }, { deep: true });

        },
        methods: {
            triggerClick($e) {
                if (!this.clickEmitted) {
                    this.clickEmitted = true
                    this.$emit('click');
                }
                else
                    this.clickEmitted = false
            },
            init() {
                if (!util.isNull(this.value)) {
                    this.vm.isSelected = this.value;
                } else {
                    this.vm.isSelected = null;
                }
            },
        },
        components: {

        }
    };
</script>

<style>
    .input-radio.sfx {
        transition: all 0.2s ease-out;
    }

        .input-radio.sfx:hover {
            color: var(--main-color);
            transition: all 0.2s ease-out;
        }
</style>
